module.exports = __webpack_public_path__ + "static/media/iconThumb.d89f516a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconThumb.svg
// module id = 959
// module chunks = 0